module.exports = __webpack_public_path__ + "img/time.e2c1bab2.svg";